import React from "react";
import { FiFilter, FiSliders } from "react-icons/fi";

const ToolbarDropdown = ({
  icon,
  label,
  value,
  options,
  onChange,
  align = "left",
  menuClassName = "",
}) => {
  const [open, setOpen] = React.useState(false);
  const ref = React.useRef(null);

  const selected = options.find((o) => o.value === value);

  React.useEffect(() => {
    const onDoc = (e) => {
      if (!ref.current) return;
      if (!ref.current.contains(e.target)) setOpen(false);
    };

    const onEsc = (e) => {
      if (e.key === "Escape") setOpen(false);
    };

    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onEsc);

    return () => {
      document.removeEventListener("mousedown", onDoc);
      document.removeEventListener("keydown", onEsc);
    };
  }, []);

  const handleSelect = (val) => {
    onChange(val);
    setOpen(false);
  };

  return (
    <div
      ref={ref}
      className={`tc-toolbar-dd ${open ? "is-open" : ""} tc-toolbar-dd--${align}`}
    >
      <button
        type="button"
        className="tc-toolbar-dd__trigger"
        onClick={() => setOpen((s) => !s)}
        aria-expanded={open}
      >
        <span className="tc-toolbar-dd__icon">{icon}</span>
        <span className="tc-toolbar-dd__label">{label}</span>

        {/* {label === "Sort" && selected ? (
          <span className="tc-toolbar-dd__selected">{selected.label}</span>
        ) : null} */}

        <span className={`tc-toolbar-dd__chev ${open ? "is-open" : ""}`}>▾</span>
      </button>

      {open && (
        <div className={`tc-toolbar-dd__menu ${menuClassName}`} role="listbox">
          {options.map((opt) => (
            <button
              key={opt.value}
              type="button"
              className={`tc-toolbar-dd__item ${opt.value === value ? "is-active" : ""}`}
              onClick={() => handleSelect(opt.value)}
            >
              <span>{opt.label}</span>
              {opt.value === value ? (
                <span className="tc-toolbar-dd__tick">✓</span>
              ) : null}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

const FilterSortBar = ({
  filterValue,
  filterOptions,
  onFilterChange,
  sortValue,
  sortOptions,
  onSortChange,
  className = "",
}) => {
  return (
    <div className={`tc-filter-sort ${className}`}>
      <ToolbarDropdown
        icon={<FiFilter />}
        label="Filter"
        value={filterValue}
        options={filterOptions}
        onChange={onFilterChange}
        align="left"
      />

      <ToolbarDropdown
        icon={<FiSliders />}
        label="Sort"
        value={sortValue}
        options={sortOptions}
        onChange={onSortChange}
        align="right"
      />
    </div>
  );
};

export default FilterSortBar;